import { css } from '@linaria/core';
export const Root = {
    base: css `
		cursor: pointer;

		box-sizing: content-box;
		width: var(--switch-sizing-track);
		height: auto;
		padding: var(--switch-padding-base);
		border-radius: var(--switch-corner-radius-base);

		background: rgb(var(--switch-color-background-alpha));

		transition: 100ms var(--global-ease-in-out) background;

		input {
			position: absolute;

			overflow: hidden;

			width: 1px;
			height: 1px;
			margin: -1px;
			padding: 0;
			border: 0;

			white-space: nowrap;

			clip: rect(0 0 0 0);
			clip-path: inset(50%);
		}

		/* Focus */
		&:focus-visible {
			outline: var(--switch-border-base) solid rgb(var(--switch-color-border-focus-alpha));
			outline-offset: calc(-1 * var(--switch-border-base));
		}

		@supports not selector(:focus-visible) {
			&:focus {
				outline: var(--switch-border-base) solid rgb(var(--switch-color-border-focus-alpha));
				outline-offset: calc(-1 * var(--switch-border-base));
			}
		}

		/* Hover */
		&:hover {
			@media (any-hover: hover), (any-pointer: fine) {
				background: linear-gradient(
						0deg,
						rgb(var(--switch-color-stateLayer-hover-alpha)) 0%,
						rgb(var(--switch-color-stateLayer-hover-alpha)) 100%
					),
					rgb(var(--switch-color-background-alpha));
			}
		}

		/* Pressed */
		&:active {
			background: linear-gradient(
					0deg,
					rgb(var(--switch-color-stateLayer-pressed-alpha)) 0%,
					rgb(var(--switch-color-stateLayer-pressed-alpha)) 100%
				),
				rgb(var(--switch-color-background-alpha));
		}
	`,
    isDisabled: css `
		cursor: default;
		opacity: 0.2;

		/* Focus */
		&:focus-visible {
			outline: none;
		}

		@supports not selector(:focus-visible) {
			&:focus {
				outline: none;
			}
		}

		/* Hover */
		&:hover {
			@media (any-hover: hover), (any-pointer: fine) {
				background: rgb(var(--switch-color-background-alpha));
			}
		}

		/* Pressed */
		&:active {
			background: rgb(var(--switch-color-background-alpha));
		}
	`,
};
export const Toggle = {
    base: css `
		position: relative;
		left: 0;

		overflow: hidden;

		width: var(--switch-sizing-handle);
		height: var(--switch-sizing-handle);
		border-radius: var(--switch-corner-radius-base);

		text-align: center;
		text-indent: -100px;
		vertical-align: middle;

		background: rgb(var(--switch-color-off-alpha));

		transition: 100ms var(--global-ease-in-out) all;
	`,
    isEnabled: css `
		left: 50%;
		background: rgb(var(--switch-color-on-alpha));
	`,
};
